import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation, useMatch } from "react-router-dom";
import OurMission from "../../Views/OurMission/ourMission";
import BecomeEducator from "../../Views/BecomeEducator/becomeEducator";
import HowItWorks from "../../Views/HowItWorks/howItWorks";
import EducatorFaq from "../../Views/Faq/educatorFaq";
import LearnerFaq from "../../Views/Faq/learnerFaq";
import Privacy from "../../Views/Privacy/privacy";
import Policies from "../../Views//Policies/policies";
import Contact from "../../Views//Contact/contact";
import EducatorAccountMainPage from "../../Views/EducatorOnBoarding/educatorAccountMainPage";
import Navbar from "../../Views/Common/Header/navbar";
import Footer from "../../Views/Common/Footer/footer";
import { Courses } from "../../Views/CoursesScreen/courses";
import CoursesSoon from "../../Views/CoursesPage/coursesSoon";
import HomeScreen from "../../Views/Home/home";
import { Dashboard } from "../../Views/Dashboard/dashboard.jsx";
import { PrivateOutlet, PrivateOutletEdu } from "./privateRoute";
import Error404 from "../../Views/Common/Error404/error404";
import { Account } from "../../Views/Account/account";
import { useDispatch, useSelector } from "react-redux";
import { fetchActiveCourses, fetchUserData } from "../States/userDataSlice";
import { EducatorProfiles } from "../../Views/EducatorProfiles/educatorProfiles";
import { CourseCreationFlow } from "../../Views/CourseCreationFlow/courseCreationFlow.jsx";
import { CourseListing } from "../../Views/CourseListing/courseListing.jsx";
import { CheckoutForm } from "../../Views/Checkout/checkout.jsx";
import { EnrollmentComplete } from "../../Views/EnrollmentComplete/enrollmentComplete.jsx";
import { ConferenceRoom } from "../../Views/ConferenceRoom/conferenceRoom.jsx";
import { CancellationPolicy } from "../../Views/CancellationPolicy/cancellationPolicy.jsx";
import { fetchFlags } from "../States/flagsSlice.js";
import { Loader } from "../../Views/Common/Loader/loader.jsx";
import useAuthentication from "../States/onAuthStateChange.js";
import CareersContainer from "../../Views/Careers/careersController.jsx";
import { database } from "../config.js";
import { get, ref } from "firebase/database";
import { initializeSteps } from "../States/educatorStepsSlice.js";
import { ShowErrorToast } from "../../Views/Common/Toast/toast.jsx";
import ERROR_CONSTANTS from "../Constants/errorConstants.js";
import { JobListing } from "../../Views/Careers/jobListing.jsx";
import { trackEvent } from "../Utilities/analytics";
import SEO from "../SEO/seo.jsx"
import paths from "../Router/paths.js"
import Blog from "../../Views/Blog/blog.jsx";
import BlogList from "../../Views/Blog/blogList.jsx";
import { fetchBlog } from "../States/blogSlice.js";
import { USER_LOGS_CLIENT } from "../Constants/logsConstant.js";
import { setCurrentRoute } from "../States/routeSlice.js";
import { safeClientLogEvent } from "../Utilities/safeClientLogEvent.js";
import OrganizationNavbar from "../../Views/OrganizationUI/Header/organizationNavbar.jsx";
import Landing from "../../Views/OrganizationUI/landing.jsx";
import About from "../../Views/OrganizationUI/About/about.jsx";

const Router = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {userId} = useAuthentication()
  const [isLoading, setIsLoading] = useState(false)
  const userData = useSelector((state) => state.userData.data);
  const isConferenceRoom = useMatch(paths.conferenceRoomPage.path);
  const flags = useSelector((state) => state.flags.flags)
  const loading = useSelector((state) => state.flags.loading)
  const isOrganizationUi = Boolean(flags?.organizations)

  useEffect(
    () => {
      if (userId) {
        dispatch(fetchUserData(userId));
      }
    },
    [dispatch, userId])
  useEffect(() => {
    const fetchUserData = async () => {
      if (!userId) return
      setIsLoading(true)
      try {
        const userRef = ref(database, `users/${userId}/`);
        const snapshot = await get(userRef);
        if (snapshot.exists()) {
          const userData = snapshot.val(); // Extract actual data
          if (userData?.educator?.onboarding_step) {
            dispatch(initializeSteps(userData.educator.onboarding_step));
          }
        } else {
          ShowErrorToast(ERROR_CONSTANTS.GENERIC_ERROR_TOAST)
        }
      } catch (error) {
          await safeClientLogEvent({
            ...USER_LOGS_CLIENT.USER_DATA_NOT_FOUND,
            source: "Router.js",
            uid: userId,
            metadata: { error: error.message, userId },
            error: error.message
          });
      } finally {
        setIsLoading(false)
      }
    };

    fetchUserData();
    // eslint-disable-next-line
  }, [userId, dispatch])
  useEffect(() => {
    dispatch(fetchActiveCourses());
  }, [dispatch])
  useEffect(() => {
    dispatch(fetchBlog());
  }, [dispatch, userData]);
  
  useEffect(() => {
    dispatch(fetchFlags());
    // eslint-disable-next-line
  }, [])

  const showFooter = !(
    location.pathname === paths.onboardingPage.path ||
    location.pathname === paths.createCoursePage.path ||
    isConferenceRoom
  )

  useEffect(() => {
    dispatch(setCurrentRoute(location.pathname));
  }, [location.pathname, dispatch])

  React.useEffect(() => {
    trackPageView()
  }, [location.pathname])
  
  function trackPageView() {
    trackEvent("Page Viewed:" + window.location.pathname)
  }

  if(isLoading){
    <Loader height={"100vh"}/>
  }

  return (
    <div>
      <SEO path={location.pathname} />
      {location.pathname !== paths.onboardingPage.path &&
        location.pathname !== paths.createCoursePage.path ? (
        isOrganizationUi ? <OrganizationNavbar /> : <Navbar />
      ) : (
        ""
      )}
      <Routes>
        {isOrganizationUi ? (
          <>
            {/* New (organizations) public UI */}
            <Route exact path={paths.home.path} element={<Landing />} />
            <Route exact path={paths.ourMission.path} element={<About />} />
            {/* Course detail stays live (unlinked publicly) so enrolled students and checkout keep working */}
            <Route
              exact
              path={paths.courseListingPage.path}
              element={<CourseListing live={true} isCoursePage={true} />}
            />
            {/* Legacy marketplace routes redirect to the landing page */}
            <Route path={paths.coursesPage.path} element={<Navigate replace to={paths.home.path} />} />
            <Route path={paths.becomeEducator.path} element={<Navigate replace to={paths.home.path} />} />
            <Route path={paths.howItWorks.path} element={<Navigate replace to={paths.home.path} />} />
            <Route path={paths.educatorFaq.path} element={<Navigate replace to={paths.home.path} />} />
            <Route path={paths.learnerFaq.path} element={<Navigate replace to={paths.home.path} />} />
          </>
        ) : (
          <>
            {/* Original public UI */}
            <Route exact path={paths.home.path} element={<HomeScreen />} />
            <Route exact path={paths.ourMission.path} element={<OurMission />} />
            {loading ? (
              <Route path={paths.coursesPage.path} element={<Loader height={"100vh"} />} />
            ) : flags?.courses ? (
              <>
                <Route path={paths.coursesPage.path} element={<Courses />} />
                <Route
                  exact
                  path={paths.courseListingPage.path}
                  element={<CourseListing live={true} isCoursePage={true} />}
                />
              </>
            ) : (
              <Route path={paths.coursesPage.path} element={<CoursesSoon />} />
            )}
            <Route exact path={paths.becomeEducator.path} element={<BecomeEducator />}></Route>
            <Route exact path={paths.howItWorks.path} element={<HowItWorks />} />
            <Route exact path={paths.educatorFaq.path} element={<EducatorFaq />} />
            <Route exact path={paths.learnerFaq.path} element={<LearnerFaq />} />
          </>
        )}
        <Route exact path={paths.careersPage.path} element={<CareersContainer />} />
        <Route exact path={paths.jobListingPage.path} element={<JobListing />} />
        <Route exact path={paths.privacyPage.path} element={<Privacy />} />
        <Route exact path={paths.policiesPage.path} element={<Policies />} />
        <Route exact path={paths.cancellationPage.path} element={<CancellationPolicy />} />
        <Route exact path={paths.contactPage.path} element={<Contact />} />
        <Route path={paths.error404.path} element={<Error404 />} />
        <Route path={paths.educatorProfilePage.path} element={<EducatorProfiles />} />

        {/* Protected routes */}
        <Route element={<PrivateOutlet />}>
          <Route path={paths.accountPage.path} element={<Account />} />
          <Route path={paths.checkoutPage.path} element={<CheckoutForm />} />
          <Route exact path={paths.dashboardPage.path} element={<Dashboard />} />
          <Route path={paths.conferenceRoomPage.path} element={<ConferenceRoom />} />
          <Route exact path={paths.createCoursePage.path} element={<CourseCreationFlow />} />
          <Route path={paths.enrollmentCompletePage.path} element={<EnrollmentComplete />} />
        </Route>

        <Route element={<PrivateOutletEdu />}>
          <Route path={paths.onboardingPage.path} element={<EducatorAccountMainPage />}/>
        </Route>
        <Route path={paths.blogPage.path} element={<BlogList />}/>
        <Route path={paths.blogListingPage.path} element={<Blog />}/>
      </Routes>
      {showFooter && <Footer />}
    </div>
  );
};

export default Router;
